// @ts-nocheck
import * as $ from 'jquery';
import { MonthlyCreditUsage } from '../../Charts/Scripts/MonthlyCreditUsage';

$(() => {
    const creditLimitsPageContainer = $('[data-credit-limits-page]');

    if (creditLimitsPageContainer.length === 0) {
        return;
    }

    let container = $(creditLimitsPageContainer[0]);

    const monthlyUsedCreditsContainer = $('[data-monthly-used-credits]');
    if (monthlyUsedCreditsContainer.length > 0) {
        $(monthlyUsedCreditsContainer[0])
            .data('monthlyUsedCredits', new MonthlyCreditUsage(monthlyUsedCreditsContainer));
    }

    const creditLimitAdjustButton = $('#SaveCreditChange');
    const creditLimitAdjust = $('#AdjustCreditLimit');
    const approvedValue = parseInt(creditLimitAdjust.attr('data-approved-value'));
    let currentlySavedValue = parseInt(creditLimitAdjust.attr('data-current-value'));
    
    let changeButton = function (current: number) {
        // Disable button if trying selecting same value as saved already
        if(currentlySavedValue==current) {
            creditLimitAdjustButton.prop("disabled",true);
        }else{
            creditLimitAdjustButton.prop("disabled",false);
        }

        // Change text on button
        if (current < approvedValue) {
            creditLimitAdjustButton.text(creditLimitAdjustButton.attr('data-save-text'))
        } else {
            creditLimitAdjustButton.text(creditLimitAdjustButton.attr('data-request-text'))
        }
    };
    
    changeButton(parseInt(creditLimitAdjust.val()))
    
    creditLimitAdjust.on('input change', function (e) {
        $('.current-range-amount').html(this.value + " kr");
        let current = parseInt(this.value);
        changeButton(current);
    });
    
    const showChangeHistory = $("#ShowChangeHistory");
    showChangeHistory.on('click', function (e) {
        $('#credit-change-history').toggle();
    });
});
